module.exports = __webpack_public_path__ + "img/CIB-logo-Red.87362892.png";